export default __webpack_public_path__ + "static/media/logo-translucent.245c381e.png";